import { useEffect, useRef } from "react";
import { Modal, Button, Accordion, Card } from "react-bootstrap";
import TokuteishohyokiMain from "../TokuteishohyokiMain";
import CustomAccordionToggle from "../common/CustomAccordionToggle";
import { useAccordionState } from "../../hooks/useAccordionState";
import {
  MAPPLE_COM_LINKS,
  TERMS_OF_VIEWER,
  TERMS_OF_USE_PATH,
  NINI_BETA_NOTICE,
  ABOUT_SECTION_NINI,
  NINI_CHIBANZU_SOURCES,
} from "../../constants/Constant";
const AboutViewerModal = ({
  show,
  handleClose,
  showPlateauModal,
  sectionRequest,
}) => {
  const { openItems, manageOpenItems, openItem } = useAccordionState([]);
  const niniSectionRef = useRef(null);

  // 任意座標の章を開いてその位置までスクロールする
  const openNiniSection = () => {
    openItem(ABOUT_SECTION_NINI);
    // モーダルの表示とアコーディオンの展開に合わせる
    setTimeout(() => {
      niniSectionRef.current?.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }, 350);
  };

  // 章を指定して開かれた場合は該当の章を展開する
  useEffect(() => {
    if (!show || sectionRequest?.section !== ABOUT_SECTION_NINI) {
      return;
    }
    openNiniSection();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [show, sectionRequest]);

  const handlePlateauLinkClick = () => {
    handleClose();
    // モーダルのフェードアウトに合わせる
    setTimeout(() => {
      showPlateauModal();
    }, 300);
  };

  return (
    <Modal show={show} onHide={handleClose} size="xl">
      <Modal.Header closeButton>
        <Modal.Title as="h5">「MAPPLE法務局地図ビューア」について</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        「MAPPLE法務局地図ビューア」はG空間情報センターで公開されている登記所備付地図データを「MAPPLEのベクトルタイル」に重ねた地図です。MAPPLEの地図と重ねることにより、不動産鑑定や土地家屋調査などの不動産関連業務、公共サービス、農業、林業、災害対応など街づくりに関する業務のDXや効率化につながります。詳しくは
        <a href={MAPPLE_COM_LINKS.PRODUCT_SITE} target="_blank" rel="noopener noreferrer">
          こちら
        </a>
        をご覧ください。 ご利用に関してのご要望、お問合せにつきましては
        <a
          href={MAPPLE_COM_LINKS.FAQ_SITE}
          target="_blank"
          rel="noopener noreferrer"
        >
          FAQ
        </a>
        または
        <a
          href={MAPPLE_COM_LINKS.CONTACT_SITE}
          target="_blank"
          rel="noopener noreferrer"
        >
          お問い合わせフォーム
        </a>
        からご連絡ください。
        <br />
        <div
          className="p-2 row"
          style={{ wordBreak: "normal", fontSize: "medium" }}
        >
          <div className="d-inline-block">
            <span style={{ color: "red", fontWeight: "bold" }}>
              {NINI_BETA_NOTICE.TITLE}
            </span>
            <br />
            {NINI_BETA_NOTICE.ITEMS.map((text, index) => (
              <span key={index}>
                ・{text}
                <br />
              </span>
            ))}
            詳しい免責事項は下記「
            <Button
              variant="link"
              className="link-opacity-100 p-0"
              style={{
                border: "none",
                verticalAlign: "baseline",
              }}
              onClick={openNiniSection}
            >
              {NINI_BETA_NOTICE.SECTION_TITLE}
            </Button>
            」をご覧ください。
          </div>
        </div>
        <br />
        <Accordion activeKey={openItems}>
          <Card>
            <Card.Header>
              <CustomAccordionToggle eventKey="0" onClick={manageOpenItems}>
                使い方
              </CustomAccordionToggle>
            </Card.Header>
            <Accordion.Collapse eventKey="0">
              <Card.Body>
                ・地図に重ねて表示しているものは公共座標系の地図データです。赤色のポリゴンをクリックすると属性が表示、地図を拡大すると地番が表示されます。
                <br />
                ・任意座標系の地図データは地図上の
                <img
                  src="mapple01/mojmap/cyoumei_whiteyellow_tate.svg"
                  alt=""
                />
                大字町名をクリックすると画像が表示されます。大字町名がない場合や仕様上紐づけができない場合は、市区町村役場の位置に
                <img
                  src="mapple01/mojmap/cyoumei_whiteyellow_tate.svg"
                  alt="アイコン"
                />
                を表示しています。複数の地図データがある場合、上部のプルダウンメニューで選択できます。
                <br />
                ・属性にG空間情報センターからダウンロードできる該当地図データのファイル名を表示しており、地図データを探すためのインデックスにもなります。
                <br />
                ・空中写真の表示：拡大すると、地図と空中写真が重なって表示されます。
                <br />
                ・現在地表示：右上のボタンをクリックすると、現在地に移動します（labs.mapple.comで位置情報の許可をしてください。機種やブラウザの設定により動作しないことがあります）
                <br />
                ・距離計測：右上のボタンをクリックした後、地図上を連続でクリックすると距離の計測ができます。
                <br />
                ・任意座標系の重ね表示（β版）：左スライダーの「位置合わせした任意座標の表示（β版）」をONにすると、位置補正した任意座標系の地図を背景地図に重ねて表示します。任意座標系の地図はオレンジ色で表示されます。ログインしていない状態ではオレンジ色のエリアのみの表示となり、地番や属性は表示されません。アカウント登録（無料）の上、ログインするとご利用いただけます。
              </Card.Body>
            </Accordion.Collapse>
          </Card>
          <Card ref={niniSectionRef}>
            <Card.Header>
              <CustomAccordionToggle
                eventKey={ABOUT_SECTION_NINI}
                onClick={manageOpenItems}
              >
                {NINI_BETA_NOTICE.SECTION_TITLE}
              </CustomAccordionToggle>
            </Card.Header>
            <Accordion.Collapse eventKey={ABOUT_SECTION_NINI}>
              <Card.Body>
                <div style={{ wordBreak: "normal" }}>
                  <span style={{ fontWeight: "bold" }}>
                    任意座標系重ね表示機能（β版）のご利用にあたってのご案内と免責事項
                  </span>
                  <br />
                  <br />
                  <span style={{ fontWeight: "bold" }}>1. 目的と精度</span>
                  <br />
                  本機能は、従来背景地図へ重ね表示ができなかった任意座標系の登記所備付地図について、位置特定を補助する目的で実験的に提供（β版）しているものです。当社の位置補正アルゴリズムにより自動処理を行っており、位置精度や完全性を保証するものではありません。
                  <br />
                  <br />
                  <span style={{ fontWeight: "bold" }}>2. 利用上の制限</span>
                  <br />
                  本機能で表示される図面・地番位置は参考情報です。現況との相違、位置のずれ、反転等が含まれる場合があります。また、重ね表示の対象自治体においても、データの整備状況等により重ね表示および地番情報の閲覧ができないエリアが存在します。本機能の利用により生じた直接的・間接的な損害について、当社は一切の責任を負いません。
                  <br />
                  <br />
                  <span style={{ fontWeight: "bold" }}>
                    3. 個別の修正・非表示要望について
                  </span>
                  <br />
                  本機能は無料β版として提供している特性上、ユーザー様個別の「位置ずれ修正」「個別図面の表示取り下げ・非表示」等のご要望には原則としてお応えできかねます。いただいたご意見は、今後の自動補正技術向上のためのフィードバックとして活用させていただきます。
                  <br />
                  <br />
                  <span style={{ fontWeight: "bold" }}>
                    4. ご利用に必要なログインについて
                  </span>
                  <br />
                  本機能で重ね表示する任意座標系の地図は、地図上にオレンジ色で表示されます（公共座標系の地図は赤色です）。ログインしていない状態では、位置合わせした任意座標のエリア（オレンジ色で表示される範囲）のみの表示となります。地番の表示、およびオレンジ色のポリゴンをクリックしての属性の表示は、アカウント登録（無料）の上、ログインしてご利用ください。
                  <br />
                  なお、大字町名アイコンから開く任意座標の地図（別ウィンドウ）は、ログインの有無にかかわらずご覧いただけます。
                </div>
              </Card.Body>
            </Accordion.Collapse>
          </Card>
          <Card>
            <Card.Header>
              <CustomAccordionToggle eventKey="1" onClick={manageOpenItems}>
                機能追加、更新情報
              </CustomAccordionToggle>
            </Card.Header>
            <Accordion.Collapse eventKey="1">
              <Card.Body>
                <span
                  style={{
                    background: "linear-gradient(transparent 70%, #FFFF00 0%)",
                  }}
                >
                  ＜2026/09/30改良＞
                </span>
                <br />
                位置合わせした任意座標系の登記所備付地図を、背景地図に重ねて表示する機能（β版）を追加しました。左スライダーの「位置合わせした任意座標の表示（β版）」で切り替えられます。参考表示のため、ご利用の前に「
                <Button
                  variant="link"
                  className="link-opacity-100 p-0"
                  style={{
                    border: "none",
                    verticalAlign: "baseline",
                  }}
                  onClick={openNiniSection}
                >
                  {NINI_BETA_NOTICE.SECTION_TITLE}
                </Button>
                」を必ずご確認ください。
                <br />
                <span
                  style={{
                    background: "linear-gradient(transparent 70%, #FFFF00 0%)",
                  }}
                >
                  ＜2026/08/01変更＞
                </span>
                <br />
                「不動産登記情報（土地）の購入機能」の決済サービスを
                <span style={{ textDecoration: "underline" }}>
                  SquareからStripe（ストライプ）へ変更
                </span>
                いたしました。決済画面や領収書メールの送付元が変わりましたが、価格や購入操作に変更はございません。Stripeで決済されている「サブスクリプション」にも影響はございません。
                <br />
                <span
                  style={{
                    background: "linear-gradient(transparent 70%, #FFFF00 0%)",
                  }}
                >
                  ＜2026/03/18改良＞
                </span>
                <br />
                地図印刷・画像出力等のサブスクリプション（有料）の開始しました。個人利用や同一部署内での地図の印刷・複製が許諾されます。右上のアカウントボタンから申し込みができます。詳しくは
                <a
                  href="https://mapple.com/news/20260318/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  こちら
                </a>
                <br />
                <span
                  style={{
                    background: "linear-gradient(transparent 70%, #FFFF00 0%)",
                  }}
                >
                  ＜2026/03/10改良＞
                </span>
                <br />
                右上アカウントボタンに「登記情報購入履歴」を実装しました。過去に購入した不動産登記情報（土地）の一覧表示や該当位置への移動ができます。
                <br />
                <span
                  style={{
                    background: "linear-gradient(transparent 70%, #FFFF00 0%)",
                  }}
                >
                  ＜2025/10/01改良＞
                </span>
                <br />
                左スライダーに「次回終了状態を再現」スイッチを設置しました。ONにすると、次回起動時に前回終了位置の地図が表示されます。
                <br />
                <span
                  style={{
                    background: "linear-gradient(transparent 70%, #FFFF00 0%)",
                  }}
                >
                  ＜2025/01/08改良＞
                </span>
                <br />
                国土交通省Project
                PLATEAUの3D都市モデル（建築物、地形）の表示機能を実装しました。詳しくは
                <Button
                  variant="link"
                  className="link-opacity-100 p-0"
                  style={{
                    border: "none",
                    verticalAlign: "baseline",
                  }}
                  onClick={handlePlateauLinkClick}
                >
                  こちら
                </Button>
                <br />
                <span
                  style={{
                    background: "linear-gradient(transparent 70%, #FFFF00 0%)",
                  }}
                >
                  ＜2024/01/22改良＞
                </span>
                <br />
                不動産登記情報（土地）の購入が、一度に複数（最大5件）できるようになりました。
                <br />
                <span
                  style={{
                    background: "linear-gradient(transparent 70%, #FFFF00 0%)",
                  }}
                >
                  ＜2023/11/30改良＞
                </span>
                <br />
                登記所備付地図の地番を検索することができます。右下の虫眼鏡ボタンをクリックすると、検索画面が表示されます。
                <br />
                <span
                  style={{
                    background: "linear-gradient(transparent 70%, #FFFF00 0%)",
                  }}
                >
                  ＜2023/09/28改良＞
                </span>
                <br />
                MAPPLE法務局地図ビューアでは不動産登記情報（土地、全部事項）を購入することができます（
                <a
                  href="https://mapple.com/news/20230928/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  プレスリリース
                </a>
                ）。
                <br />
                詳しい使い方は
                <a
                  href="https://labs.mapple.com/mapple03/mojmap/marual_mapple_registry.pdf"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  こちら
                </a>
                、または{" "}
                <a href="https://youtu.be/0kV-AVe55Mo" data-lity="data-lity">
                  <i
                    className="fa fa-youtube-play"
                    style={{
                      color: "#0078FF",
                      fontSize: "30px",
                      display: "inline-block",
                      verticalAlign: "middle",
                    }}
                    aria-hidden="true"
                  ></i>
                </a>
                <br />
                <span
                  style={{
                    background: "linear-gradient(transparent 70%, #FFFF00 0%)",
                  }}
                >
                  ＜2023/07/06改良＞
                </span>
                <br />
                ・アカウント登録、ログイン機能：右スライダーメニュー内の「ログイン」ボタンを押すとログイン画面（アカウント登録画面）が開きます。
                <br />
                ・アカウント登録は無料です。
                <br />
                ・アカウント登録し、ログインをすると使用できる機能については、
                <a
                  href={MAPPLE_COM_LINKS.PRODUCT_SITE}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  製品サイト
                </a>
                をご覧ください。
                <br />
                ・GeoJSONダウンロード機能：地図上で登記所備付地図をクリックし、右スライダーメニューの属性表示欄のGeoJSONボタンを押すと、GeoJSONファイルをダウンロードできます。GeoJSONファイルは、
                <a
                  href="https://smd.mapple.net/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  スーパーマップル・デジタル
                </a>
                等、GeoJSONに対応しているGISソフトで読み込むことができます。ダウンロードできるのは、弊社地図と重なっている公共座標の地図です。ログインしていない状態ではダウンロードできません。
                <br />
                詳しくは
                <a
                  href="https://mapple.com/column/20230706/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  こちら
                </a>
                、または
                <a
                  href="https://www.youtube.com/watch?v=p34NZVbTC-c"
                  data-lity="data-lity"
                >
                  <i
                    className="fa fa-youtube-play"
                    style={{
                      color: "#0078FF",
                      fontSize: "30px",
                      display: "inline-block",
                      verticalAlign: "middle",
                    }}
                    aria-hidden="true"
                  ></i>
                </a>

              </Card.Body>
            </Accordion.Collapse>
          </Card>
          <Card>
            <Card.Header>
              <CustomAccordionToggle eventKey="2" onClick={manageOpenItems}>
                出典
              </CustomAccordionToggle>
            </Card.Header>
            <Accordion.Collapse eventKey="2">
              <Card.Body>
                ・登記所備付地図データ（法務省）（
                <a
                  href="https://front.geospatial.jp/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  G空間情報センター
                </a>
                から2026年4月にダウンロード）
                <br />
                ・登記所備付地図データ（法務省）を加工して作成
                <br />
                <br />
                <div style={{ wordBreak: "normal" }}>
                  {NINI_CHIBANZU_SOURCES.TITLE}
                  <br />
                  {NINI_CHIBANZU_SOURCES.LICENSE_GROUPS.map((group) => (
                    <span key={group.license}>
                      ・{group.license}
                      <br />
                      {group.items.map((item, index) => (
                        <span key={item.city}>
                          {index > 0 && "、"}
                          {item.city}「
                          {item.showUrl ? (
                            item.data
                          ) : (
                            <a
                              href={item.url}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              {item.data}
                            </a>
                          )}
                          」
                          {item.showUrl && (
                            <a
                              href={item.url}
                              target="_blank"
                              rel="noopener noreferrer"
                              style={{ wordBreak: "break-all" }}
                            >
                              {item.url}
                            </a>
                          )}
                          {item.termsUrl && (
                            <>
                              （
                              <a
                                href={item.termsUrl}
                                target="_blank"
                                rel="noopener noreferrer"
                              >
                                {NINI_CHIBANZU_SOURCES.TERMS_TEXT}
                              </a>
                              ）
                            </>
                          )}
                        </span>
                      ))}
                      <br />
                    </span>
                  ))}
                </div>
              </Card.Body>
            </Accordion.Collapse>
          </Card>
          <Card>
            <Card.Header>
              <CustomAccordionToggle eventKey="3" onClick={manageOpenItems}>
                推奨ブラウザー
              </CustomAccordionToggle>
            </Card.Header>
            <Accordion.Collapse eventKey="3">
              <Card.Body>
                このページはHTML5ベースで開発しており、Google Chrome/Microsoft
                Edge/Mozilla
                Firefox/Safariの最新版で動作を確認しています。なお、OSや設定によって正常に動作しない可能性があります。
                <br />
              </Card.Body>
            </Accordion.Collapse>
          </Card>
          <Card>
            <Card.Header>
              <CustomAccordionToggle eventKey="4" onClick={manageOpenItems}>
                特定商取引法に基づく表記
              </CustomAccordionToggle>
            </Card.Header>
            <Accordion.Collapse eventKey="4">
              <Card.Body>
                <TokuteishohyokiMain />
              </Card.Body>
            </Accordion.Collapse>
          </Card>
          <Card>
            <Card.Header>
              <CustomAccordionToggle eventKey="5" onClick={manageOpenItems}>
                プライバシーポリシー
              </CustomAccordionToggle>
            </Card.Header>
            <Accordion.Collapse eventKey="5">
              <Card.Body>
                <div
                  style={{
                    wordBreak: "normal",
                    fontSize: "small",
                  }}
                >
                  <p>プライバシーポリシー</p>
                  <b>昭文社グループ</b>
                  <p>
                    プライバシーポリシーに関しましては、
                    <a
                      href="https://www.mapple.co.jp/privacy/"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      昭文社グループのプライバシーポリシー
                    </a>
                    に準拠します。
                  </p>
                </div>
              </Card.Body>
            </Accordion.Collapse>
          </Card>
          <Card>
            <Card.Header>
              <CustomAccordionToggle eventKey="6" onClick={manageOpenItems}>
                会社概要
              </CustomAccordionToggle>
            </Card.Header>
            <Accordion.Collapse eventKey="6">
              <Card.Body>
                <div
                  style={{
                    wordBreak: "normal",
                    fontSize: "small",
                  }}
                >
                  <p>会社概要</p>
                  <b>株式会社マップル</b>
                  <p>
                    こちらをご参照ください。
                    <a
                      href="https://mapple.com/about/#profile"
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      株式会社マップルホームページ
                    </a>
                  </p>
                </div>
              </Card.Body>
            </Accordion.Collapse>
          </Card>
          <Card>
            <Card.Header>
              <CustomAccordionToggle eventKey="7" onClick={manageOpenItems}>
                ご利用サポート、お問い合わせ
              </CustomAccordionToggle>
            </Card.Header>
            <Accordion.Collapse eventKey="7">
              <Card.Body>
                <nav style={{ paddingLeft: '0.5rem', marginTop: '0.5rem' }}>
                  <ul className="list-unstyled" style={{ fontSize: '0.85rem' }}>
                    {[
                      { href: MAPPLE_COM_LINKS.SUBSCRIPTION_NEWS, icon: 'fa-info-circle', text: 'サブスクリプションの詳細' },
                      { href: MAPPLE_COM_LINKS.REGISTRY_NEWS, icon: 'fa-file-text-o', text: '不動産登記情報（土地）の購入' },
                      { href: MAPPLE_COM_LINKS.FAQ_SITE, icon: 'fa-question-circle', text: 'よくあるご質問（FAQ）' },
                      { href: MAPPLE_COM_LINKS.CONTACT_SITE, icon: 'fa-envelope', text: 'お問い合わせ' },
                      { href: MAPPLE_COM_LINKS.PRODUCT_SITE, icon: 'fa-external-link', text: '製品サイト' },
                      { href: MAPPLE_COM_LINKS.SURVEY_SITE, icon: 'fa-pencil-square-o', text: 'アンケート' },
                    ].map((item, index) => (
                      <li key={index} style={{ marginBottom: '0.8rem' }}> {/* 項目間の余白をここで確保 */}
                        <a
                          href={item.href}
                          target="_blank"
                          rel="noopener noreferrer"
                          style={{
                            display: 'flex',          // アイコンとテキストを分離
                            alignItems: 'flex-start', // 2行になってもアイコンを上に固定
                            lineHeight: '1.4',        // 項目内の行間をタイトに
                            textDecoration: 'none'
                          }}
                        >
                          <i
                            className={`fa ${item.icon} me-2`}
                            aria-hidden="true"
                            style={{ marginTop: '0.2rem', width: '1.2rem', textAlign: 'center' }} // アイコンの位置と幅を固定
                          ></i>
                          <span>{item.text}</span>
                        </a>
                      </li>
                    ))}
                  </ul>
                </nav>
              </Card.Body>
            </Accordion.Collapse>
          </Card>
          <Card>
            <Card.Header>
              <CustomAccordionToggle eventKey="8" onClick={manageOpenItems}>
                利用規約
              </CustomAccordionToggle>
            </Card.Header>
            <Accordion.Collapse eventKey="8">
              <Card.Body>
                【MAPPLE法務局地図ビューア　利用規約】
                <br />
                <br />
                <iframe
                  src={TERMS_OF_VIEWER}
                  className="w-100 border border-1"
                  height="300"
                  title="Viewer Terms"
                ></iframe>
                <br />
                <br />
                【MAPPLE法務局地図ビューア　アカウント利用規約】（アカウント登録のお客様）
                <br />
                <br />
                <iframe
                  src={TERMS_OF_USE_PATH}
                  className="w-100 border border-1"
                  height="300"
                  title="Account Terms"
                ></iframe>
              </Card.Body>
            </Accordion.Collapse>
          </Card>
        </Accordion>
      </Modal.Body>
      <Modal.Footer>
        2026 Copyright MAPPLE, Inc. <br />
        <Button variant="primary" className="w-100" onClick={handleClose}>
          MAPPLE法務局地図ビューアを見る
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AboutViewerModal;

